function getBaseUrl() {
  // Default is intended to be reverse-proxied by Nginx:
  //   /zenbridge/*  ->  https://api.zenbridge.io/*
  return (process.env.REACT_APP_ZENBRIDGE_BASE_URL || "/zenbridge").replace(
    /\/$/,
    ""
  );
}

function getAuthHeaderValue() {
  const raw = process.env.REACT_APP_ZENBRIDGE_BEARER_TOKEN;
  if (!raw) return null;
  return raw.startsWith("Bearer ") ? raw : `Bearer ${raw}`;
}

async function readErrorBody(res) {
  const contentType = res.headers.get("content-type") || "";
  try {
    if (contentType.includes("application/json")) {
      return await res.json();
    }
    return await res.text();
  } catch {
    return null;
  }
}

async function request(path, { method = "GET", headers, body } = {}) {
  const baseUrl = getBaseUrl();
  const url = `${baseUrl}${path.startsWith("/") ? "" : "/"}${path}`;

  const authHeaderValue = getAuthHeaderValue();

  const res = await fetch(url, {
    method,
    headers: {
      ...(body ? { "Content-Type": "application/json" } : {}),
      ...(authHeaderValue ? { Authorization: authHeaderValue } : {}),
      ...(headers || {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  const contentType = res.headers.get("content-type") || "";
  const isJson = contentType.includes("application/json");
  const rawText = isJson ? null : await res.text();
  const data = isJson
    ? await res.json()
    : (() => {
        // Some proxies forget to set content-type; try to parse JSON anyway.
        const t = (rawText || "").trim();
        if (!t) return t;
        if (t.startsWith("{") || t.startsWith("[")) {
          try {
            return JSON.parse(t);
          } catch {
            return t;
          }
        }
        return t;
      })();

  if (!res.ok) {
    const errBody = data ?? (await readErrorBody(res));
    const msg =
      (errBody && errBody.error) ||
      (typeof errBody === "string" && errBody) ||
      `Request failed (${res.status})`;
    const error = new Error(msg);
    error.status = res.status;
    error.body = errBody;
    throw error;
  }

  return data;
}

export const zenbridge = {
  get: (path) => request(path, { method: "GET" }),
  post: (path, body) => request(path, { method: "POST", body }),
  put: (path, body) => request(path, { method: "PUT", body }),
};


